<template>
  <b-modal
    id="modal-edit-activity-type"
    cancel-variant="outline-secondary"
    centered
    size="sm"
    title=""
    :ok-disabled="false"
    hide-header
    hide-footer
  >
    <div class="text-center w-100">
      <h5 class="colorWhite">{{ isEdit ? "修改" : "新增" }}活動類型</h5>
      <a @click="hide" class="close-button">
        <feather-icon class="colorWhite" icon="XIcon" size="18" />
      </a>
    </div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form class="" @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_sort_order"
                > 
                <b-form-group
                      label="排序："
                      label-for="sort_order"
                      label-cols-md="4"
                      class="require"
                    >
                  <b-form-input
                    v-model="projectData.sort_order"
                    class="d-inline-block"
                    placeholder="排序"
                    type="number"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>
            <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name"
                > 
                <b-form-group
                      label="活動類型名稱："
                      label-for="name"
                      label-cols-md="4"
                      class="require"
                    >
                  <b-form-input
                    v-model="projectData.name"
                    class="d-inline-block"
                    placeholder="活動類型名稱"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col>
            <b-col
              cols="12"
              class="d-flex flex-wrap justify-content-center w-100 p-2"
            >
              <b-button
                variant="primary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1 px-3"
                type="submit"
              >
                提交
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                class="px-3"
                @click="hide"
              >
                取消
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>
  
  <script>
import Ripple from "vue-ripple-directive";
import store from "@/store";
import { ref, watch, onUnmounted, onMounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, alphaNum, email } from "@validations";

import {
  BModal,
  BButton,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
  BOverlay,
} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      required
    };
  },
  props: {
    projectData: {},
    isEdit: {},
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-edit-activity-type");
    },
    resetModal() {
      this.projectData = {id:0}
      this.$emit("fouceIsEditFalse");
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "確定",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("project/editActivityType", this.projectData)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.loading = false;
              this.hide();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.loading = false;
            });
        }
      });
    },
  },
  watch: {},
  setup(props) {
    const loading = ref(false);
    const resetContractData = () => {
      props.projectData = { id: 0,sort_order:0 };
    };
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetContractData);


    return {
      refFormObserver,
      getValidationState,
      resetForm,
      loading,
    };
  },
};
</script>
  
<style lang="scss">

</style>
  